import React from 'react'
import useCashFundPreferences from 'src/routes/(registry)/list/[slug]/hooks/useCashFundPreferences'
import { PaymentPreferenceSettingsProps } from 'registry/settings-page/cash-fund-preferences/PaymentPreferenceSettings/PaymentPreferenceSettings.types'
import useFeatureFlag from 'shared/hooks/useFeatureFlag/useFeatureFlag'
import {
  legacySaveRequestBody,
  paymentPreferencesSaveRequestBody,
} from 'src/routes/(registry)/api/helpers'
import PaymentPreferencesForm from 'src/routes/(registry)/list/[slug]/components/CashFundPreferencesDrawer/components/PaymentPreferencesForm/PaymentPreferencesForm'
import { successMessage } from 'lib/flash-message'
import { CashFundPreferences } from 'src/types/registry'
import { noPaymentPreferencesSelected } from 'src/routes/(registry)/list/[slug]/utils/cashFundHelpers'
import { Button } from '../../../../baby-design'
import css from './PaymentPreferenceSettings.styles.scss'

const PaymentPreferenceSettings: React.FC<PaymentPreferenceSettingsProps> = ({
  onPreferencesSaved,
  preferences: initialPreferences,
}) => {
  const { flagValue: isPaymentPreferenceFormEnabled } = useFeatureFlag(
    '24d_ff_regex_cash_fund_upgrades_web',
    false
  )

  const mapRequestBody = isPaymentPreferenceFormEnabled
    ? paymentPreferencesSaveRequestBody
    : legacySaveRequestBody

  const handleSaveSuccessful = (newPreferences: CashFundPreferences) => {
    successMessage(`Cash fund preferences have been successfully saved!`)
    if (onPreferencesSaved) {
      onPreferencesSaved(newPreferences)
    }
  }

  const {
    isLoading,
    cashFundPreferences,
    setCashFundPreferences,
    setErrors,
    setShowPreferenceRequired,
    showPreferenceRequired,
    onSave,
    errors,
  } = useCashFundPreferences(initialPreferences, mapRequestBody, {
    onSuccess: handleSaveSuccessful,
  })

  const updateCashFundPreferences = (
    newCashFundPreferences: CashFundPreferences
  ) => {
    setShowPreferenceRequired(false)
    setCashFundPreferences(newCashFundPreferences)
  }

  const handleSave = () => {
    if (noPaymentPreferencesSelected(cashFundPreferences)) {
      setShowPreferenceRequired(true)
      return
    }
    onSave()
  }

  const showAppliesToAllFundsWarning =
    !noPaymentPreferencesSelected(cashFundPreferences)

  return (
    <div className={css.PaymentPreferenceSettings}>
      <PaymentPreferencesForm
        errors={errors}
        preferences={cashFundPreferences}
        setErrors={setErrors}
        showAppliesToAllFundsWarning={showAppliesToAllFundsWarning}
        showPreferenceRequired={showPreferenceRequired}
        onPreferencesUpdated={updateCashFundPreferences}
      />
      <Button
        className={css.PaymentPreferenceSettings__SaveButton}
        disabled={isLoading}
        size="md"
        variant="primary"
        onClick={handleSave}
      >
        Save
      </Button>
    </div>
  )
}

export default PaymentPreferenceSettings
